exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-group[data-v-5b5416f1] {\n  margin-bottom: 15px;\n}\n.margin-top-10[data-v-5b5416f1] {\n  margin-top: 10px;\n}\n.margin-left-5[data-v-5b5416f1] {\n  margin-left: 5px;\n}\n", ""]);

// exports
